import api from 'common/api'
import { YANADOO_AI_HOST } from 'common/config'

export async function fetchUsable(userSeq, promptType) {
  const res = await api.get(`${YANADOO_AI_HOST}/usable/${userSeq}/${promptType}`)
  return res.data
}
